import {onMounted, onBeforeUnmount} from 'vue';

export function useDocumentListener<K extends keyof DocumentEventMap>(
    event: K,
    handler: (event: DocumentEventMap[K]) => void,
    options?: boolean | AddEventListenerOptions,
) {
    onMounted(() => document.addEventListener(event, handler, options));
    onBeforeUnmount(() => document.removeEventListener(event, handler, options));
}
